import React from "react";

interface GoalToggleButtonProps {
    selected: boolean;
    onToggle: () => void;
    className: string;
    children: React.ReactNode;
}

export const GoalToggleButton: React.FC<GoalToggleButtonProps> = ({
    selected,
    onToggle,
    className,
    children,
}) => (
    <button
        type="button"
        aria-pressed={selected}
        onClick={onToggle}
        className={`text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-500 ${
            selected
                ? "bg-brand-100 ring-2 ring-brand-600"
                : "bg-white ring-1 ring-gray-200 hover:bg-gray-50 hover:ring-gray-300"
        } ${className}`}>
        {children}
    </button>
);
